export default __webpack_public_path__ + "static/media/recordTransparent.894dfa66.png";